// @flow

import type {Action} from '../../types'
import type {PlaceState} from '../types'
import type {SetPaginationPayload} from '../actions/setPagination'

export function setPaginationReducer(state: PlaceState, action: Action<SetPaginationPayload>): PlaceState {

  return {
    ...state,
    pagination: action.payload.pagination,
  }
}
